import * as React from 'react';
import { Row, Col } from 'antd';
import { TableRowSelection } from 'antd/lib/table';
import { resolve } from 'inversify-react';
import { observer } from 'mobx-react';

import { ZuluIcon } from 'src/app/shared/icon';
import { FormatService } from 'src/core/services/format.service';
import { Column, DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { DataLocalService } from 'src/core/services/data-local.service';

interface TourInfoCardProps {
	parent: any;
	subProducts: any[];
	fromDate: (item) => Date;
	toDate: (item) => Date;
	productName: (item) => string;
	mode: ControlMode;
	isPackage?: boolean;
	setBusy?: () => void;
	expandedRenderer?: (item: any) => any;
	getSubProcKeys: (item: any) => string;
	selection?: false | TableRowSelection<any>;
	priceRenderer: (item: any, record: any) => string | React.ReactNode;
	extraColumn?: Column;
}

@observer
export class TourInfoCard extends React.Component<TourInfoCardProps, {}> {
	@resolve
	private formatService: FormatService;

	public render() {
		if (!this.props.subProducts) {
			return null;
		}
		const dataset = new DataLocalService(this.props.subProducts);
		const columns: Column[] = [
			{
				key: 'product',
				dataIndex: '',
				title: 'Itinerary',
				render: (text: any, record: TourProductSearchResult) => {
					const placeNode = (record.productType === 1 || record.productType === 5) && (record as AccommodationSearchResult).place != null
						? <Col span={24}><ZuluIcon type='environment' /> {(record as AccommodationSearchResult).place.code}</Col>
						: null;
					return (
						<Row>
							<Col span={24}>
								{this.renderIcon(record)} {this.props.productName(record)}
							</Col>
							{placeNode}
						</Row>
					);
				}
			},
			{
				key: 'from',
				dataIndex: '',
				title: 'Date from',
				render: (text: any, record: { startDate: Date }) => {
					return this.formatService.toString('small-date-time', this.props.fromDate(record), 'utc');
				}
			},
			{
				key: 'to',
				dataIndex: '',
				title: 'Date to',
				render: (text: any, record: { endDate: Date }) => {
					return this.formatService.toString('small-date-time', this.props.toDate(record), 'utc');
				}
			},
		]
		if (!this.props.isPackage) {
			columns.push({
				key: 'price',
				dataIndex: 'sellPrice',
				title: 'Price',
				render: (text: any, record: any) => {
					return this.props.priceRenderer(text, record);
				}
			});
		}
		if (this.props.extraColumn) {
			columns.push(this.props.extraColumn);
		}

		return (
			<DataTableView
				rowKey={this.props.getSubProcKeys}
				mode="display"
				setBusy={this.props.setBusy}
				hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hidePagination}
				columns={columns}
				model={dataset}
				expandedRowRender={this.props.expandedRenderer}
				selection={this.props.selection}
			/>
		);
	}

	private renderIcon = (item: TourProductSearchResult) => {
		switch (item.productType) {
			case 1:
			case 5: // Accommodation
				return (<ZuluIcon type='icon-hotel' />);
			case 2:
				return <ZuluIcon type='car' />;
			case 3:
				return <ZuluIcon type='icon-train' />;
			case 4:
				return <ZuluIcon type='icon-plane' />;
		}
		return <ZuluIcon type='tags' />;
	}
};



// WEBPACK FOOTER //
// ./src/app/bookings/quote-entries/parts/tour-info-card.tsx